import type { StorageServiceInterface } from './types';

const isSupported = (): boolean => !!window?.localStorage;

const setItem = (key: string, value: string): void => {
  if (isSupported()) window.localStorage.setItem(key, value);
};

const getItem = (key: string): string | undefined => {
  if (isSupported()) {
    const item = window.localStorage.getItem(key);
    if (item) return item;
  }
  return undefined;
};

const hasItem = (key: string): boolean => !!getItem(key);

const removeItem = (...keys: string[]): void => {
  if (isSupported())
    keys.forEach((key) => {
      window.localStorage.removeItem(key);
    });
};

const clear = (): void => {
  if (isSupported()) window.localStorage.clear();
};

const addItemTupleToList = (list: [string, string][], name: string): [string, string][] => {
  const value = getItem(name);
  return value ? [...list, [name, value]] : list;
};

const getAll = (): [string, string][] =>
  isSupported() ? Object.keys(window.localStorage).reduce(addItemTupleToList, []) : [];

export const LocalStorageService: StorageServiceInterface<string> = {
  isSupported,
  setItem,
  getItem,
  hasItem,
  removeItem,
  clear,
  getAll,
};
